import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { getStore } from "base/basestore";
import { getS3FileKey } from "base/utils";

import { useSignStore } from "../editors/signature/signature.store";

import styles from "./style.css";

export function Signature(props) {
  const { value, height = "100%", column, row, instanceId } = props;
  const [flowData, setFlowData] = useState({});
  const publicFormDataUrl = useSignStore((state) =>
    state.getSignatureData(row.id, column.id)
  );

  useEffect(
    function setFlowDataFromInstanceId() {
      if (instanceId) {
        // eslint-disable-next-line no-unused-vars
        const useFormStore = getStore(instanceId);
        const flowData = useFormStore.getState().flowData;
        setFlowData(flowData);
      }
    },
    [instanceId]
  );

  const getStyle = () => {
    let url = flowData.isPublicForm
      ? publicFormDataUrl
      : value && `/upload/2/${getS3FileKey(value.key)}`;

    return url
      ? {
          backgroundImage: `url(${url})`,
          height: height
        }
      : {};
  };
  return <div className={styles.signature} style={getStyle()} />;
}

Signature.propTypes = {
  value: PropTypes.any,
  height: PropTypes.string,
  column: PropTypes.object,
  row: PropTypes.object,
  instanceId: PropTypes.string
};
